import { Injectable } from "@angular/core";
import { validate } from "codelyzer/walkerFactory/walkerFn"; import {LOCAL_STORAGE} from "../constants";

@Injectable( {
	providedIn: "root"
} )
export class StorageService{
	constructor(
	){}

	/**
	 * It will return data from specified key.
	 * @param key : key string for getting data.
	 */
	getLocalStorage( key: string ) {
		try {
			return JSON.parse( localStorage.getItem( key ) );
		} catch ( error ) {
			return localStorage.getItem( key );
		}
	}

	/**
	 * It will set value by specified key.
	 * @param key : key string.
	 * @param value : value to be stored.
	 */
	setLocalStorage( key: string, value: any ): void {
		try {
			if(value instanceof Object) {
				return localStorage.setItem( key, JSON.stringify(value) ) ;
			} else {
				return localStorage.setItem( key, value.toString() ) ;
			}
		} catch ( error ) {
			return error;
		}
	}

	/**
	 * It will delete data by specified key.
	 * @param key : key string.
	 */
	deleteLocalStorage( key: string ): void {
		try {
			return localStorage.removeItem( key );
		} catch ( error ) {
			return error;
		}
	}

	/**
	 * Get parsed value from session storage
	 * @param key : key to get data from session storage
	 */
	getSessionStorage( key: string ) {
		return JSON.parse( sessionStorage.getItem( key ) );
	}

	/**
	 * Set stringified value by key in session storage
	 */
	setSessionStorage( key: string, value: any ): void {
		return sessionStorage.setItem( key, JSON.stringify( value ) );
	}

	/**
	 * Set stringified value by key in session storage
	 */
	deleteSessionStorage( key: string ): void {
		return sessionStorage.removeItem( key );
	}

	/**
	 * Saves the search History of tilteSearch in localstorage
	 * @param term the Search Term to save
	 */
	saveSearch( term: string ) {
		if ( !term || term.length <3 ) {
			return;
		}
		let history: any = JSON.parse( localStorage.getItem( "searchHistory" ) );
		if ( !Array.isArray( history ) || history.length < 1 ) {
			history = [];
		}
		if ( history.length >= 1 ) {
			let minIndex = 0;
			let min = history[0].date;
			let duplicate = false;
			history.forEach( ( value, index ) => {
				if ( value.term.toLowerCase() === term.toLowerCase() ) {
					duplicate = true;
				}
				if ( value.date < min ) {
					min = value.date;
					minIndex = index;
				}
			} );
			if ( duplicate ) {
				return;
			}
			if ( history.length >= 4 ) {
				history.splice( minIndex, 1 );
			}
		}
		history.push( { term: term, date: new Date() } );
		localStorage.setItem( "searchHistory", JSON.stringify( history ) );
	}

	/**
	 * Returns the saved search History as array of strings
	 */
	getSearchHistory(): Array<string> {
		const history: any = JSON.parse( localStorage.getItem( "searchHistory" ) );
		if ( !Array.isArray( history ) || history.length < 1 ) {
			return [];
		}
		return history.map( ( entry ) => {
			return entry.term;
		} );
	}

	clearSearchHistory() {
		localStorage.removeItem( "searchHistory" );
	}

	clearLocalStorage() {
		localStorage.removeItem(LOCAL_STORAGE.INVOICE_ADDRESS);
		localStorage.removeItem(LOCAL_STORAGE.DELIVERY_DATE);
		localStorage.removeItem(LOCAL_STORAGE.DELIVERY_ADDRESS);
		localStorage.removeItem(LOCAL_STORAGE.DELIVERY_OPTION);
		localStorage.removeItem(LOCAL_STORAGE.CART);
		localStorage.removeItem(LOCAL_STORAGE.INVOICE_EMAIL);
	}
}
